import Image from 'next/image'
import { useState, useEffect } from 'react'
import { RatingTierModal } from '../RatingTierModal'
import styles from './styles.module.scss'

export const ScoreInfo = ({ ratingData }) => {
  const [visibleRatingTier, setVisibleRatingTier] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleMouseEnter = () => {
    if (!isMobile) {
      setVisibleRatingTier(true)
    }
  }

  const handleMouseLeave = () => {
    if (!isMobile) {
      setVisibleRatingTier(false)
    }
  }

  const handleClickModal = () => {
    if (isMobile) {
      setVisibleRatingTier(true)
    }
  }

  const handleCloseModal = event => {
    event.stopPropagation()
    setVisibleRatingTier(false)
  }

  return (
    <div className={styles.ratingInfo}>
      <div className={styles.ratingInfo__top}>
        <h3 className={styles.ratingInfo__title}>
          {ratingData?.attributes.ratingAttribute.data.attributes.name}:{' '}
          {ratingData?.attributes?.score} <span>★</span>
        </h3>
        <div
          className={styles.ratingInfo__image}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClickModal}
        >
          <Image
            src='/assets/icons/icon-info.svg'
            alt='Information'
            width={24}
            height={24}
          />
          {visibleRatingTier && (
            <RatingTierModal
              attributes={
                ratingData?.attributes.ratingAttribute.data.attributes
              }
              closeModal={handleCloseModal}
              modalStyle='modalAbove'
            />
          )}
        </div>
      </div>
      <article
        className={styles.ratingInfo__content}
        dangerouslySetInnerHTML={{
          __html: ratingData?.attributes?.content,
        }}
      />
    </div>
  )
}
